import { useEffect, useState } from "react";
import { RotateCcw, CheckCircle2, Clock3, ChevronDown } from "lucide-react";
import { Section } from "./ui";
import { customerApi, inr, formatDate } from "../../lib/api";

const KIND_LABEL = { ride: "Ride", order: "Food", private_car: "Private car" };

export default function RefundHistoryCard() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { customerApi.refunds().then(setData).catch(() => setData({ refunds: [], count: 0, total_credited: 0, total_pending: 0 })); }, []);
  if (!data) return null;
  const refunds = data.refunds || [];
  if (refunds.length === 0) return null;
  const shown = open ? refunds : refunds.slice(0, 3);
  return (
    <Section title="Refunds" description="Money returned to you for cancelled or changed bookings.">
      <div className="space-y-2" data-testid="refund-history">
        <div className="flex flex-wrap gap-2 text-xs">
          {data.total_credited > 0 && <span className="rounded-full bg-green-100 px-2.5 py-1 font-semibold text-green-800" data-testid="refund-total-credited">{inr(data.total_credited)} credited</span>}
          {data.total_pending > 0 && <span className="rounded-full bg-amber-100 px-2.5 py-1 font-semibold text-amber-800" data-testid="refund-total-pending">{inr(data.total_pending)} in progress</span>}
        </div>
        {shown.map((r) => {
          const credited = r.status === "credited";
          return (
            <div key={`${r.kind}-${r.ref_id}`} className="flex items-start justify-between gap-3 rounded-2xl border border-surface-200 bg-white p-3" data-testid={`refund-item-${r.ref_id}`}>
              <div className="flex items-start gap-2.5">
                {credited ? <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-green-600" /> : <Clock3 className="mt-0.5 h-4 w-4 shrink-0 text-amber-500" />}
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-ink">{KIND_LABEL[r.kind] || "Refund"}{r.subtitle ? <span className="font-normal text-ink-soft"> · {r.subtitle}</span> : null}</p>
                  <p className="text-xs text-ink-muted">{formatDate(r.date)} · {credited ? "Credited to your original payment method" : "Processing — usually 5–7 business days"}</p>
                </div>
              </div>
              <p className="shrink-0 text-sm font-bold text-ink">{inr(r.amount)}</p>
            </div>
          );
        })}
        {refunds.length > 3 && (
          <button type="button" onClick={() => setOpen((o) => !o)} className="flex w-full items-center justify-center gap-1 rounded-xl py-2 text-xs font-semibold text-brand hover:bg-brand-50" data-testid="refund-history-toggle">
            <RotateCcw className="h-3.5 w-3.5" /> {open ? "Show less" : `Show all ${refunds.length} refunds`} <ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
          </button>
        )}
      </div>
    </Section>
  );
}
